/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  user: {}
};

export default {
  state
};
